import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {Switch} from '@mui/material'

interface Props {
    isOn: (() => boolean) | boolean
    toggle: () => void | Promise<void>
    isDisabled?: boolean
    switchKey?: string
    className?: string
}

function _ToggleSwitch({isOn, toggle, isDisabled, switchKey, className}: Props) {
    const on = typeof isOn === 'function' ? isOn() : isOn

    const changeState = React.useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation()
            if (toggle) {
                toggle()
            }
        },
        [toggle]
    )

    return (
        <Switch
            className={className}
            onClick={changeState}
            checked={on}
            disabled={!!isDisabled}
            data-cy={on ? 'btn-deactivate' : 'btn-activate'}
            id={switchKey ? (on ? `button-${switchKey}-is-on` : `button-${switchKey}-is-off`) : undefined}
        />
    )
}
export const ToggleSwitch = observer(_ToggleSwitch)
